import EmergenzaEdit from "./components/EmergenzaEdit.vue";
import EmergenzaView from "./components/EmergenzaView.vue";
import EmergenzaList from "./components/EmergenzaList.vue";

export default {
    EmergenzaEdit,
    EmergenzaView,
    EmergenzaList,
};
